import React, { useState, useRef, useEffect } from "react";
import {
  View,
  FlatList,
  TouchableOpacity,
  Text,
  TextInput,
  StyleSheet,
} from "react-native";
import NSText from "./NSText";
import { Feather } from "@expo/vector-icons";
import { FONT_FAMILY } from "@common/styles";

const shadowStyle = {
  marginBottom: 2,
  shadowColor: "#000",
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.25,
  shadowRadius: 3.84,
  elevation: 5,
};

const GlobalMultiSelectPickerV2 = ({
  width,
  coords,
  data,
  selectedIndices,
  onItemPress,
  hasSearch,
}: {
  width: number;
  coords: { x: number; y: number };
  data: { id: string; title: string }[];
  selectedIndices?: number[];
  onItemPress: (id: string, index: number) => void;
  hasSearch?: boolean;
}) => {
  const [search, setSearch] = useState<string>("");
  const [searchData, setSearchData] =
    useState<{ id: string; title: string }[]>(data);
  const dataStoredInRef = useRef<{ id: string; title: string }[]>(data);

  useEffect(() => {
    onSearch?.(search);
  }, [search]);

  const onSearch = (search: string) => {
    let updatedData = dataStoredInRef.current.filter((i) =>
      i?.title?.toLowerCase?.()?.includes?.(search.toLowerCase())
    );
    setSearchData(updatedData);
  };

  return (
    <View style={[styles?.container, { width, top: coords.y, left: coords.x }]}>
      {data?.length ? (
        <>
          {hasSearch ? (
            <TextInput
              style={[
                styles?.searchTextInput,
                //@ts-ignore
                { outline: "none" },
              ]}
              placeholder="Search"
              value={search}
              onChangeText={setSearch}
              //@ts-ignore
              onClick={(e) => e.stopPropagation()}
              autoFocus
              onKeyPress={({ nativeEvent }) => {
                if (nativeEvent?.key === "Enter") {
                  // searchOnPress(search)
                }
              }}
            />
          ) : (
            <></>
          )}
          {searchData.length ? (
            <FlatList
              showsVerticalScrollIndicator={false}
              data={searchData}
              keyExtractor={(_, index) => index.toString()}
              renderItem={({ item, index }) => {
                return (
                  <TouchableOpacity
                    style={[
                      styles?.itemTO,
                      {
                        backgroundColor: selectedIndices?.includes(index)
                          ? "#6300A31A"
                          : "",
                        borderTopStartRadius: index === 0 ? 5 : 0,
                        borderTopEndRadius: index === 0 ? 5 : 0,
                        borderBottomStartRadius:
                          index === data?.length - 1 ? 5 : 0,
                        borderBottomEndRadius:
                          index === data?.length - 1 ? 5 : 0,
                      },
                    ]}
                    onPress={() => {
                      onItemPress(item?.id, index);
                    }}
                  >
                    <View
                      style={[
                        styles?.itemView,
                        {
                          borderColor: selectedIndices?.includes(index)
                            ? "#6300A3"
                            : "#7D7D7D",
                          backgroundColor: selectedIndices?.includes(index)
                            ? "#6300A3"
                            : "",
                        },
                      ]}
                    >
                      {selectedIndices?.includes(index) ? (
                        <Feather name="check" size={12} color="white" />
                      ) : null}
                    </View>
                    <NSText
                      style={{
                        maxWidth: "90%",
                        flexShrink: 1,
                        marginStart: 10,
                        fontSize: 12,
                        color: selectedIndices?.includes(index)
                          ? "#303030"
                          : "#7D7D7D",
                      }}
                      text={item?.title}
                    />
                  </TouchableOpacity>
                );
              }}
            />
          ) : (
            <View style={styles?.noFilterView}>
              <Text style={styles?.noFilterText}>No Filter Available</Text>
            </View>
          )}{" "}
        </>
      ) : (
        <View style={styles?.noFilterView}>
          <Text style={styles?.noFilterText}>No Filter Available</Text>
        </View>
      )}
    </View>
  );
};

export default GlobalMultiSelectPickerV2;

const styles = StyleSheet?.create?.({
  container: {
    position: "absolute",
    maxHeight: 300,
    borderRadius: 5,
    backgroundColor: "#F7F2FA",
    ...shadowStyle,
  },
  searchTextInput: {
    marginBottom: 2,
    paddingVertical: 7,
    paddingHorizontal: 15,
    fontFamily: "NotoSans",
    fontSize: 12,
    color: "#303030",
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#6300A3",
    backgroundColor: "white",
  },
  itemTO: {
    flexDirection: "row",
    padding: 10,
    alignItems: "center",
    elevation: 5,
  },
  itemView: {
    width: 16,
    height: 16,
    borderWidth: 2,
    borderRadius: 2,
    alignItems: "center",
    justifyContent: "center",
  },
  itemText: { maxWidth: "90%", flexShrink: 1, marginStart: 10, fontSize: 12 },
  noFilterView: { padding: 15 },
  noFilterText: {
    color: "#2a2a2a",
    fontSize: 12,
    fontFamily: FONT_FAMILY.notosans,
  },
});
